import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import { MobileExpandableDetailCard, MobileStatusChip } from '../../components/mobile'
import { MOBILE_SECTION_DIVIDER_COLOR } from '../../components/mobile/styles/mobileColors'
import { UI_COLOR_PRIMARY } from '../../constants/uiColors'
import { formatMoney } from '../../helpers/utils'
import { getRefundStatusOption } from '../helpers/refundDisplay'

const MOBILE_CARD_DIVIDER_COLOR = MOBILE_SECTION_DIVIDER_COLOR
const MOBILE_CARD_ACCENT = UI_COLOR_PRIMARY

const buildRefundStatusUI = (model) => {
  const statusUI = getRefundStatusOption(model)

  if (statusUI) return statusUI

  return {
    label: String(model?.status || '-').toUpperCase(),
    className: ''
  }
}

const buildRefundSummaryRows = (model, getFormattedDate) => [
  {
    label: 'Fecha',
    value: getFormattedDate(model.created_date),
    valueTitle: getFormattedDate(model.created_date)
  },
  {
    label: 'Cliente',
    value: `${model.client_db_ref} - ${model.client_description}`,
    valueTitle: `${model.client_db_ref} - ${model.client_description}`
  },
  {
    label: 'Monto',
    value: formatMoney(Number(model.total)),
    valueTitle: formatMoney(Number(model.total))
  }
]

const buildRefundDetailRows = (model) => [
  {
    detailRowKey: `${model.uuid}-salesman`,
    icon: <SupervisorAccountIcon sx={{ fontSize: 20 }} />,
    label: 'Creado por',
    value: `${model.salesman_db_ref} - ${model.salesman_name}`,
    valueTitle: `${model.salesman_db_ref} - ${model.salesman_name}`,
    valueSx: {
      display: 'block',
      wordBreak: 'break-word'
    },
    dividerColor: MOBILE_CARD_DIVIDER_COLOR
  }
]

const buildRefundFooter = (model) => {
  const statusUI = buildRefundStatusUI(model)

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        component="span"
        sx={{
          flexShrink: 0,
          fontSize: 14,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.04
        }}
      >
        Estado:
      </Typography>
      <Box sx={{ minWidth: 0 }}>
        <MobileStatusChip
          statusUI={statusUI}
          sx={{
            minWidth: 112,
            '& .MuiChip-label': {
              whiteSpace: 'normal',
              textAlign: 'center'
            }
          }}
        />
      </Box>
    </Stack>
  )
}

const RefundMobileCard = ({
  model,
  getFormattedDate,
  openRefundInNewTab,
  expanded,
  onToggleExpand
}) => {
  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ minWidth: 0, display: 'flex', alignItems: 'stretch' }}>
      <MobileExpandableDetailCard
        code={model.db_ref}
        onCodeClick={() => openRefundInNewTab(model.uuid)}
        expanded={expanded}
        onToggleExpand={onToggleExpand}
        summaryRows={buildRefundSummaryRows(model, getFormattedDate)}
        detailRows={buildRefundDetailRows(model)}
        accentColor={MOBILE_CARD_ACCENT}
        codeAccentColor={MOBILE_CARD_ACCENT}
        detailDividerColor={MOBILE_CARD_DIVIDER_COLOR}
        footerContent={buildRefundFooter(model)}
        footerDivider
        footerDividerColor={MOBILE_CARD_DIVIDER_COLOR}
        footerPaddingTop={1.5}
        expandAriaLabel={expanded ? 'Ocultar detalle de la devolución' : 'Mostrar detalle de la devolución'}
        detailRegionAriaLabel={`Detalle de la devolución ${model.db_ref}`}
        bodyFontSize={14}
        codeFontSize={14}
        summaryLabelFontSize={14}
        summaryValueFontSize={14}
        detailLabelFontSize={14}
        detailValueFontSize={14}
      />
    </Grid>
  )
}

export default RefundMobileCard
